import { useEffect, useState } from 'react';
import { Flex, Icon, SimpleGrid, Text, useColorModeValue } from '@chakra-ui/react';
import { MdCheckCircle, MdThumbUp, MdPeople, MdAccountBalance } from 'react-icons/md';
import Card from 'components/card/Card';
import { getSessionCandidateId } from 'helpers/session';

interface Stats {
  total: number;
  confirmados: number;
  promovidos: number;
  fondos: number;
}

export default function StatsBar() {
  const [stats, setStats] = useState<Stats>({ total: 0, confirmados: 0, promovidos: 0, fondos: 0 });

  const fetchStats = async () => {
    try {
      const candidateId = getSessionCandidateId();
      const endpoint = new URL(`${process.env.REACT_APP_URL_SERVER}/stats`);
      if (candidateId) {
        endpoint.searchParams.set('idCandidato', String(candidateId));
      }

      const res = await fetch(endpoint.toString(), { credentials: 'include' });
      const data = await res.json();
      setStats(data);
    } catch (e) {}
  };

  useEffect(() => {
    fetchStats();
    const t = setInterval(fetchStats, 5000);
    return () => clearInterval(t);
  }, []);

  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const subColor = 'secondaryGray.600';
  const pct = stats.total > 0 ? ((stats.confirmados / stats.total) * 100).toFixed(1) : '0.0';

  const items = [
    {
      label: 'Votos Confirmados',
      value: stats.confirmados.toLocaleString('es-MX'),
      sub: `${pct}% del padrón total`,
      icon: MdCheckCircle,
      iconColor: 'green.400',
    },
    {
      label: 'Promovidos',
      value: stats.promovidos.toLocaleString('es-MX'),
      sub: 'Voto probable confirmado',
      icon: MdThumbUp,
      iconColor: 'yellow.400',
    },
    {
      label: 'Total Padrón',
      value: stats.total.toLocaleString('es-MX'),
      sub: 'Votantes registrados',
      icon: MdPeople,
      iconColor: 'blue.400',
    },
    {
      label: 'Fondos Disponibles',
      value: `$${Number(stats.fondos).toLocaleString('es-MX')}`,
      sub: 'Balance campaña',
      icon: MdAccountBalance,
      iconColor: 'purple.400',
    },
  ];

  return (
    <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} gap="20px" mb="20px">
      {items.map((item) => (
        <Card key={item.label} p="20px">
          <Flex align="center" justify="space-between">
            <Flex direction="column">
              <Text color={subColor} fontSize="sm" fontWeight="500" mb="6px">
                {item.label}
              </Text>
              <Text color={textColor} fontSize="2xl" fontWeight="700" lineHeight="100%">
                {item.value}
              </Text>
              <Text color={subColor} fontSize="xs" mt="6px">
                {item.sub}
              </Text>
            </Flex>
            <Icon as={item.icon} color={item.iconColor} w="44px" h="44px" />
          </Flex>
        </Card>
      ))}
    </SimpleGrid>
  );
}
